export default {
  path: 'purchase',
  meta: {
    title: '采购管理'
  },
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'supplier',
      meta: {
        title: '供应商管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '供应商管理',
            ignoreBreadCrumb: true
          },
          name: 'self-purchase-supplier-manage',
          component: () => import('@/view/v5/purchase/supplier-manage.vue')
        },
        {
          path: 'add',
          meta: {
            title: '新增供应商'
          },
          component: () => import('@/view/v5/purchase/edit.vue')
        },
        {
          path: 'edit',
          name: 'store-supplier-add',
          meta: {
            hideInTabBar: true,
            title: '编辑供应商'
          },
          component: () => import('@/view/v5/purchase/edit.vue')
        },
        {
          path: ':id',
          name: 'store-supplier-detail',
          meta: {
            hideInTabBar: true,
            title: '供应商详情'
          },
          component: () => import('@/view/v5/purchase/detail.vue')
        }
      ]
    },
    {
      path: 'detail',
      meta: {
        title: '创建订单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-detail-add',
          meta: {
            title: '创建采购单',
            add: true,
            billFlag: 'CGD',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          path: 'edit/:id',
          name: 'purchase-detail-edit',
          meta: {
            title: '编辑采购单',
            billFlag: 'CGD',
            edit: true,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          // 销售订单接单
          path: 'receive/:orderId',
          meta: {
            title: '订单编辑',
            hideInTabBar: true,
            edit: true,
            pending: true
          },
          name: 'self-order-receive',
          component: () => import('@/view/v5/order/detail.vue')
        },
        {
          path: 'audit/:id',
          name: 'purchase-detail-audit',
          meta: {
            title: '采购单审批',
            billFlag: 'CGD',
            audit: true,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        }
      ]
    },
    // 旧
    {
      path: 'list',
      meta: {
        title: '采购单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-list-manage',
          meta: {
            title: '采购单列表',
            billFlag: 'CGD',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/self/purchase/list/index.vue')
        }
      ]
    },
    // 新
    {
      path: 'v5',
      meta: {
        title: '采购单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          name: 'purchase-v5-list',
          meta: {
            title: '采购单列表',
            billFlag: 'CGD',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/list/index.vue')
        }
      ]
    },
    {
      path: 'query',
      name: 'purchase-query',
      meta: {
        title: '采购查询'
      },
      component: () => import('@/view/v5/purchase/query/index.vue')
    },
    {
      path: 'serverList',
      meta: {
        title: '服务单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-list-manage',
          meta: {
            title: '服务单列表',
            billFlag: 'SFD',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/server/list.vue')
        },
        {
          path: 'service',
          name: 'purchase-detail-add-sfd',
          meta: {
            title: '创建服务单',
            add: true,
            billFlag: 'SFD',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          path: 'service/edit/:id',
          name: 'purchase-detail-edit',
          meta: {
            title: '编辑服务单',
            billFlag: 'SFD',
            edit: true,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          path: 'service/audit/:id',
          name: 'purchase-detail-audit',
          meta: {
            title: '服务单审批',
            billFlag: 'SFD',
            audit: true,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          path: 'service/check/:id',
          name: 'purchase-detail-check',
          meta: {
            title: '查看服务单',
            billFlag: 'SFD',
            check: true,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/serve-detail.vue')
        }
      ]
    },
    {
      path: 'receipt',
      meta: {
        title: '采购收货单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-receipt-list',
          meta: {
            title: '采购收货单列表',
            billType: 'SHD'
          },
          component: () => import('@/view/v5/purchase/receipt/index.vue')
        },
        {
          path: 'detail/:relBillId',
          name: 'purchase-receipt-detail',
          meta: {
            title: '采购收货单详情',
            showOrderHeader: false
          },
          component: () => import('@/view/v5/purchase/receipt/detail.vue')
        },
        {
          path: 'query',
          name: 'purchase-receipt-query',
          meta: {
            title: '采购收货单查询'
          },
          component: () =>
            import('@/view/v5/purchase/receipt/query/receipt.vue')
        }
      ]
    },
    {
      path: 'receiptBack',
      meta: {
        title: '采购退货单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-receipt-back-list',
          meta: {
            title: '采购退货单列表',
            billType: 'THD'
          },
          component: () => import('@/view/v5/purchase/receipt/back-list.vue')
        },
        {
          path: 'detail/:relBillId',
          name: 'purchase-receipt-back-detail',
          meta: {
            title: '采购退货单详情',
            showOrderHeader: false
          },
          component: () => import('@/view/v5/purchase/receipt/back.vue')
        },
        {
          path: 'query',
          name: 'purchase-receipt-back-query',
          meta: {
            title: '采购退货单查询'
          },
          component: () => import('@/view/v5/purchase/receipt/query/back.vue')
        }
      ]
    },
    {
      path: 'receiptBack/new',
      name: 'purchase-receipt-back-new',
      meta: {
        title: '新增退货单',
        showOrderHeader: false,
        isAdd: true
      },
      component: () => import('@/view/v5/purchase/receipt/back.vue')
    },
    // 旧
    {
      path: 'po',
      meta: {
        title: '采购单查询'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-order-manage',
          meta: {
            title: '采购单查询',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/self/purchase/pur/index.vue')
        },
        {
          path: ':id',
          meta: {
            hideInTabBar: true,
            title: '采购单详情'
          },
          component: () => import('@/view/self/purchase/pur/detail.vue')
        }
      ]
    },
    // 新
    {
      path: 'detail',
      meta: {
        title: '采购单详情'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'purchase-order-manage',
          meta: {
            title: '新建采购单',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/pur/index.vue')
        },
        {
          path: ':id',
          meta: {
            hideInTabBar: true,
            title: '编辑采购单'
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        }
      ]
    },
    {
      path: 'server',
      meta: {
        title: '服务单查询',
        ignoreBreadCrumb: true
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'service-management',
          meta: {
            title: '服务单查询'
          },
          component: () => import('@/view/v5/purchase/server/index.vue')
        }
      ]
    },
    {
      path: 'statement',
      meta: {
        title: '对账管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '对账管理',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/statement')
        },
        {
          path: 'project/:code',
          meta: {
            title: '项目详情'
          },
          component: () => import('@/view/v5/purchase/statement/project.vue')
        },
        {
          path: 'supplier/:id',
          meta: {
            title: '供应商详情'
          },
          component: () => import('@/view/v5/purchase/detail.vue')
        },
        {
          path: 'po/:id',
          meta: {
            title: '采购单详情'
          },
          component: () => import('@/view/v5/purchase/pur/detail.vue')
        },
        {
          path: 'detail/:code',
          meta: {
            title: '对账单详情'
          },
          component: () => import('@/view/v5/purchase/statement/detail.vue')
        }
      ]
    },
    {
      path: 'payment',
      meta: {
        title: '付款管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'self-payment-list',
          meta: {
            title: '付款管理',
            notCache: false,
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/purchase/payment/index.vue')
        },
        {
          path: 'history',
          name: 'self-payment-history',
          meta: {
            title: '付款操作明细'
          },
          component: () => import('@/view/v5/purchase/payment/pay-history.vue')
        },
        {
          path: 'change',
          name: 'self-payment-change',
          meta: {
            title: '多付款变更记录'
          },
          component: () => import('@/view/v5/purchase/payment/pay-change.vue')
        },
        {
          path: 'detail',
          meta: {
            hideInTabBar: true,
            title: '付款单详情'
          },
          component: () => import('@/view/v5/purchase/payment/detail.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/purchase.js